import axios from 'axios';
import qs from 'qs';

let base = '';

export const requestPost = (e, url, params) => {
    if (sessionStorage.getItem('token'))
        params.token = sessionStorage.getItem('token');
    return axios.post(url, qs.stringify(params)).then(res => {

        if (res.data.ret == 0) {
            if (res.data.code == '-1010') {
                return res.data;
            } else {
                e.$message({
                    message: res.data.msg,
                    type: 'error'
                });
                return '';
            }

        } else return res.data

    });
};




// WEBPACK FOOTER //
// ./src/api/api.js